import React from 'react';
import Layout from '../components/Layout';
import { Link } from 'react-router-dom';
import '../styles/Home.css';

// Import images
import aboutImage from '../assets/about-thumbnail.png';
import projectsImage from '../assets/projects-thumbnail.png';
import blogImage from '../assets/blog-thumbnail.png';

export default function Home() {
  return (
    <Layout>
      <div className="home-container">
        <div className="content-wrapper">
          <div className="home-header">
            <h1 className="title">Marcus Webb</h1>
            <p className="subtitle">
              Lead MLOps & Platform Engineer
            </p>
            <p className="description">
              Proven Machine Learning Ops and Platform Engineer with 8+ years of experience designing, building, and scaling cloud-native ML infrastructure. Specializing in CI/CD automation, cloud security hardening, and FinOps governance across AWS, GCP, and Azure.
            </p>
            <div className="highlight-badges">
              <span className="badge">AWS SageMaker</span>
              <span className="badge">GCP Vertex AI</span>
              <span className="badge">Kubernetes (GKE)</span>
              <span className="badge">Databricks (DAB)</span>
              <span className="badge">CI/CD Platforms</span>
              <span className="badge">FinOps</span>
            </div>
          </div>

          <div className="card-grid">
            <Link to="/about" className="card">
              <div className="card-image">
                <img src={aboutImage} alt="About Me" />
              </div>
              <div className="card-content">
                <h2 className="card-title">About Me</h2>
                <p className="card-description">Learn about my professional timeline, core technical skill sets, and academic background in mathematics.</p>
              </div>
            </Link>

            <Link to="/projects" className="card">
              <div className="card-image">
                <img src={projectsImage} alt="Projects" />
              </div>
              <div className="card-content">
                <h2 className="card-title">Projects</h2>
                <p className="card-description">Explore my developer portfolio, from custom search engines to mobile games built with Kotlin.</p>
              </div>
            </Link>

            <Link to="/blog" className="card">
              <div className="card-image">
                <img src={blogImage} alt="Blog" />
              </div>
              <div className="card-content">
                <h2 className="card-title">Blog</h2>
                <p className="card-description">Read technical posts and insights on scaling shared CI/CD, keyless cloud authentication, and automation.</p>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}
